import { makeStyles } from "@material-ui/core/styles";
import { useContext } from "react";
import { ThemeContext } from "../../Context/Theme";
export const useNavigationStyles = () => {
  const { dark } = useContext(ThemeContext);

  const drawerWidth = 230;

  const useStyles = makeStyles((theme) => ({
    root: {
      display: "flex",
      flexGrow: 1,
    },
    appBar: {
      zIndex: theme.zIndex.drawer + 1,
      transition: theme.transitions.create(["margin", "width"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      background: dark
        ? "#333333"
        : "linear-gradient(360deg, #c2d6d6 10%, #e0ebeb 360%)",
    },
    loginMain: {
      padding: 0,
      margin: 0,
      boxSizing: "border-box",
      flexGrow: 1,
    },
    appBarShift: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
      transition: theme.transitions.create(["margin", "width"], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    menuButton: {
      marginRight: 36,
    },
    hide: {
      display: "none",
    },
    drawer: {
      width: drawerWidth,
      flexShrink: 0,
      whiteSpace: "nowrap",
    },

    drawerOpen: {
      width: drawerWidth,
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      background: dark
        ? "#333333"
        : "linear-gradient(360deg, #c2d6d6 10%, #e0ebeb 360%)",
      border: "none",
    },
    drawerClose: {
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      overflowX: "hidden",
      width: theme.spacing(7) + 1,
      [theme.breakpoints.up("sm")]: {
        width: theme.spacing(9) + 1,
      },
      background: dark
        ? "#333333"
        : "linear-gradient(360deg, #c2d6d6 10%, #e0ebeb 360%)",
      border: "none",
    },

    drawerHeader: {
      display: "flex",
      alignItems: "center",
      padding: theme.spacing(0, 1),
      ...theme.mixins.toolbar,
      justifyContent: "space-between",
      background: dark
        ? "#333333"
        : "linear-gradient(360deg, #c2d6d6 10%, #e0ebeb 360%)",
      border: "none",
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
      backgroundColor: dark ? "#212121" : "#f2f2f2",
      minHeight: 1000,
      height: "100%",
    },
    mt20: {
      marginTop: "20px",
    },
    contentShift: {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    },
    brandStylesI: {
      fontWeight: "bold",
    },
    brandStylesII: {
      fontWeight: "bold",
      marginLeft: "20px",
    },
    active: {
      color: "#007cff",
    },
    inactive: {
      color: theme.palette.primary.main,
    },
    spacing: {
      flexGrow: 1,
    },
    mr20: {
      marginRight: "20px",
    },
    ml20: {
      marginLeft: "20px",
    },
    accountIconStyles: {
      color: "#007cff",
      width: "35px",
      height: "35px",
    },
    dNone: {
      display: "none",
    },
    routeMargin: {
      marginTop: 50,
    },
    activationNotification: {
      position: "fixed",
      top: "0",
      left: "0",
      zIndex: "10099887678",
      width: "100%",
      heigh: "20px",
      background: "red",
      color: "white",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    mt20: {
      marginTop: "20px",
    },
  }));

  const classes = useStyles();

  return classes;
};
